export default __webpack_public_path__ + "static/media/assets.61732da3.svg";